<template>
  <div>
    <!-- 公告展示 -->
    <Modal
      v-model="notice.isShow"
      class="notice"
      width="600"
      scrollable
      :closable="false"
      @on-visible-change="cancelHandler"
    >
      <div
        slot="header"
        style="display:flex;justify-content: space-between; align-items: center;margin-bottom: 25px;"
      >
        <div style="display: flex;">
          <div
            @click="getMessage(false)"
            class="is_viewed left"
            :class="is_viewed === false ? 'selected' : ''"
          >
            {{ $t("notice_detail.unread") + ` (${notice.unread_count || 0})` }}
          </div>
          <div
            @click="getMessage(true)"
            class="is_viewed right"
            :class="is_viewed !== false ? 'selected' : ''"
          >
            {{ $t("notice_detail.all") + ` (${notice.count || 0})` }}
          </div>
          <div class="all_read" @click="set_all_readed">
            {{ $t("notice_detail.all_read") }}
          </div>
        </div>
        <Icon
          size="20"
          color="#fff"
          style="cursor: pointer;"
          @click="notice.isShow = false"
          type="md-close"
        />
      </div>
      <div class="notice_container">
        <div style="height:431px; position:relative;">
          <template
            v-if="
              is_viewed !== false
                ? notice.dataList.length > 0
                : notice.unreadList.length > 0
            "
          >
            <div style="height: 375px">
              <div
                class="message"
                v-for="message in is_viewed !== false
                  ? notice.dataList
                  : notice.unreadList"
                :key="message.notice_id"
              >
                <div class="info">
                  <Badge v-if="!message.is_viewed" dot :offset="[6, 4]">
                    <div
                      class="message_type"
                      :style="{
                        color: notice_colors[get_notice_type(message)]
                      }"
                      style="flex-shrink: 0;"
                    >
                      <div class="is_qa" v-if="message.notice_type == 3">
                        <div class="qa_text"></div>
                      </div>
                      {{ $t(`notice_detail['${get_notice_type(message)}']`) }}
                    </div>
                  </Badge>
                  <div
                    v-else
                    class="message_type"
                    :style="{ color: notice_colors[get_notice_type(message)] }"
                    style="flex-shrink: 0;"
                  >
                    <div class="is_qa" v-if="message.notice_type == 3">
                      <div class="qa_text"></div>
                    </div>
                    {{ $t(`notice_detail['${get_notice_type(message)}']`) }}
                  </div>

                  <div class="text">
                    <div class="message_title">{{ message.title }}</div>
                    <div class="message_time">
                      <!-- 活动名字和会议名字 -->
                      <div
                        style="display:flex;align-items: center;max-width: calc(100% - 160px);"
                        v-if="message.event_name"
                      >
                        <div
                          class="name one-ellipsis"
                          :title="
                            `${message.event_name}${
                              message.session_name
                                ? ` / ${message.session_name}`
                                : ''
                            }`
                          "
                        >
                          <span>{{ message.event_name }}</span>
                          <span v-if="message.session_name" style="margin:0 3px"
                            >></span
                          >
                          <span v-if="message.session_name">{{
                            message.session_name
                          }}</span>
                        </div>
                      </div>
                      <div
                        v-if="message.event_name"
                        style="background:rgb(117, 117, 117); width: 2px;height:14px;margin: 0 10px"
                      ></div>
                      <!-- 发送时间 -->
                      <div>
                        {{
                          message.due_time
                            ? message.due_time
                            : message.created_at | formatDate
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="view" @click="viewNoticeDetail(message)">
                  {{ $t("notice_detail.view") }}
                </div>
              </div>
            </div>
            <Page
              @on-change="changPage"
              :page-size="notice.getNoticeListParams.page_size"
              :total="is_viewed !== false ? notice.count : notice.unread_count"
              :current="notice.getNoticeListParams.page_index"
              size="small"
              show-total
            />
          </template>
          <template v-else>
            <div class="no_event">
              <div class="no_event_img"></div>
              <div class="no_event_font">{{ $t("confirmMsg.no_notice") }}</div>
            </div>
          </template>
        </div>

        <!-- <span></span> -->
      </div>
      <div slot="footer"></div>
    </Modal>
    <!-- 展示详情 -->
    <Modal
      v-model="notice.showContent"
      width="800px"
      class="notice_content"
      :closable="false"
      @on-visible-change="cancelHandler"
    >
      <div slot="header">
        <div
          style="display: flex;justify-content: space-between;align-items: center;"
        >
          <div style="font-size: 25px;font-weight: 600;">
            {{ notice.notice_detail.title }}
          </div>
          <div style="cursor: pointer;" @click="close_notice_detail">
            <Icon size="35" type="ios-close" />
          </div>
        </div>
        <div style="font-size: 14px;color: #d9d9d9; margin-top: 5px;">
          {{ notice.notice_detail.created_at | formatDate }}
        </div>
      </div>

      <div class="notice_container">
        <div class="father custom-scroll">
          <div
            class="content"
            v-html="notice.notice_detail.content"
            @click="previewImgHandler"
          ></div>
          <div class="accessory" v-if="notice.media_list.length > 0">
            <div
              style="margin-top:50px;border-radius: 5px 5px 0 0; display: flex;align-items: center; background:  #303030;padding:5px"
            >
              <img src="../../static/images/link.svg" alt="" />
              <div style="margin-left:10px;">
                {{
                  $t("notice_detail.accessory") +
                    ` ( ${notice.media_list.length} )`
                }}
              </div>
            </div>
            <div
              style="padding: 5px;border-radius: 0 0 5px 5px;background: #757575;"
            >
              <div
                v-for="accessory in notice.media_list"
                :key="accessory.media_id"
                class="accessory_item"
              >
                <div style="display:flex;align-items:center;font-size: 14px;">
                  <img src="../../static/images/file.svg" alt="" />
                  <div
                    style="display:flex;margin-left:5px;flex-direction: column;justify-content: space-around;"
                  >
                    <span>{{ accessory.media_title }}</span>

                    <div
                      class="download_accessory"
                      @click="download_accessory(accessory)"
                    >
                      {{ $t("notice_detail.download_accessory") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="vertical-scroll">
          <div class="rail"></div>
        </div> -->
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import {
  get_notice_list_by_user,
  get_notice_detail_by_user,
  set_notice_readed_by_user,
  get_notice_media_download_url
} from "@/api/notice";
export default {
  name: "NoticeModal",
  props: {
    show: {
      type: Boolean
    },
    unread_count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      notice: {
        isShow: false,
        // unread_count: 0,
        count: 0,
        dataList: [],
        unreadList: [],
        showContent: false,
        notice_detail: "",
        media_list: [],
        getNoticeListParams: {
          is_viewed: 0,
          page_size: 5,
          page_index: 1,
          title: ""
        },
        timerId: ""
      },
      notice_types: ["in_station", "active", "session", "qa"],
      notice_colors: {
        in_station: "#4d4d4d",
        active: "#2D8CFF",
        session: "#31D26F"
      },
      is_viewed: false,
      total_pages: 0
    };
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal == true) {
          this.notice.getNoticeListParams.page_size = 5;
          this.notice.isShow = this.show;
          this.notice.getNoticeListParams.page_index = 1;
          this.is_viewed = false;
          this.get_notice_list_by_user();
          this.get_unreaded_notice_list();
        }
      }
    },
    unread_count: {
      handler(newVal, oldVal) {
        if (newVal > oldVal) {
        }
      }
    }
  },

  methods: {
    close_notice_detail() {
      this.notice.showContent = false;
      console.log(this.notice.unread_count);
      if (!this.is_viewed) {
        this.notice.unread_count / this.notice.getNoticeListParams.page_size
        let max_page = Math.ceil(
        );
        if (max_page < this.notice.getNoticeListParams.page_index) {
          this.notice.getNoticeListParams.page_index = max_page;
        }
        // if()
        this.get_unreaded_notice_list();
      }
    },
    previewImgHandler(e) {
      if (e.target.tagName !== "IMG") return;
      // this.previewImg = e.target.src;
      // this.isPreviewImg = true;
      this.$hevueImgPreview({ url: e.target.src });
      // console.log(e)
    },
    // 下载附件
    download_accessory(accessory) {
      get_notice_media_download_url({
        media_id: accessory.media_id,
        notice_id: this.notice.notice_detail.notice_id
      }).then(res => {
        this.$util.downloadFile(res.body.url, accessory.media_title);
      });
      this.$util.add_action_log("notice", {
        action: "download",
        notice_id: this.notice.notice_detail.notice_id,
        media_id: accessory.media_id
      });
    },
    // 获取消息类型
    get_notice_type(notice) {
      if (notice.event_id === null && notice.session_id === null) {
        return this.notice_types[0];
      }
      if (notice.event_id !== null && notice.session_id === null) {
        return this.notice_types[1];
      }
      if (notice.event_id !== null && notice.session_id !== null) {
        return this.notice_types[2];
      }
    },
    // 全部已读
    set_all_readed() {
      set_notice_readed_by_user().then(res => {
        this.get_notice_list_by_user();
        this.get_unreaded_notice_list();
        this.$util.add_action_log("notice", {
          action: "set_all_readed"
        });
      });
    },
    // 分页
    changPage(index) {
      this.notice.getNoticeListParams.page_index = index;
      if (this.is_viewed === false) {
        this.get_unreaded_notice_list();
      } else {
        this.get_notice_list_by_user();
      }
    },
    // 获取未读和全部
    getMessage(type) {
      this.notice.getNoticeListParams.page_size = 5;
      this.is_viewed = type;
      this.notice.getNoticeListParams.page_index = 1;
      if (type === false) {
        this.get_unreaded_notice_list();
        this.$util.add_action_log("notice", { action: "switch_unreaded_tab" });
      } else {
        this.get_notice_list_by_user();
        this.$util.add_action_log("notice", { action: "switch_all_tab" });
      }
    },
    // 取消对话框
    cancelHandler(flag) {
      if (flag === false) {
        // this.notice.getNoticeListParams.page_size = 0;
        // console.log(123123123)
        // this.notice.getNoticeListParams.page_index = 1;

        this.$emit("update:show", this.notice.isShow);
      } else {
      }
    },
    //初始化内容容器
    initContentWrap() {
      this.$nextTick(() => {
        var fatherScrollHeight, fatherClientHeight; // 父高度,滚动高度
        var warp = document.querySelector(".father");
        fatherClientHeight = warp.clientHeight; // 获取父高度
        fatherScrollHeight = warp.scrollHeight; // 获取父可滚动高度
        var present = fatherClientHeight / fatherScrollHeight; // 计算滚动条应该占多高
        var scroll = document.querySelector(".vertical-scroll");
        console.log(fatherClientHeight, fatherScrollHeight);
        if (fatherClientHeight == fatherScrollHeight) {
          scroll.style.display = "none";
          return;
        } else {
          scroll.style.display = "block";
        }
        var scrollWarp = document.querySelector(".rail");
        scrollWarp.style.height = present * 100 + "%"; // 用百分比计算rail的高度
        warp.scrollTop = 0;
        warp.removeEventListener("scroll", scroll);
        warp.addEventListener("scroll", function scroll(e) {
          // 添加滚动事件
          // console.log(e.target.scrollTop);
          scrollWarp.style.transform =
            "translateY(" +
            (e.target.scrollTop * 100) / fatherClientHeight +
            "%)";
        });
      });
    },
    // 展示公告
    // 获取所有公告列表
    get_notice_list_by_user() {
      this.notice.getNoticeListParams.is_viewed = "";
      get_notice_list_by_user(this.notice.getNoticeListParams).then(res => {
        // if (this.notice.getNoticeListParams.page_size != 0) {
        // console.log(res, "res");
        this.notice.dataList = res.body.notice_list;
        this.notice.count = res.total_count;
        // }
        this.notice.unread_count = res.body.unread_notice_count;
      });
    },
    // 获取未读列表
    get_unreaded_notice_list() {
      this.notice.getNoticeListParams.is_viewed = false;
      return new Promise(resolve => {

        get_notice_list_by_user(this.notice.getNoticeListParams).then(res => {
          this.notice.unreadList = res.body.notice_list;
          this.$emit("update:pop_notice_list", res.body.notice_list);
          this.$emit("update:total_count", res.total_count);
          this.notice.unread_count = res.total_count;
          resolve(res)
        });
      })
    },
    // 查看公告详情
    viewNoticeDetail(row) {
      // this.notice.isShow = false;

      get_notice_detail_by_user({ notice_id: row.notice_id }).then(async res => {
        this.notice.notice_detail = res.body.notice;
        this.notice.media_list = res.body.media_list;
        // if(this.notice.getNoticeListParams.page_index > this.total_pages){
        //   this.notice.getNoticeListParams.page_index = this.total_pages
        // }
        this.notice.showContent = true;
        // this.initContentWrap();
        await this.get_unreaded_notice_list();
        this.$util.add_action_log("notice", {
          action: "viewDetail",
          noticeId: row.notice_id,
          event_id: row.event_id,
          session_id: row.session_id
        });
      });

      // his.initContentWrap();
    }
  }
};
</script>

<style scoped lang="less">
.content {
  /deep/ img {
    &:hover {
      cursor: pointer;
    }
  }
}
.no_event {
  position: absolute;
  top: 50%;
  left: 50%;
  // width: 300px;
  transform: translate(-50%, -50%);
  z-index: 5;
  text-align: center;
  .no_event_img {
    display: inline-block;
    width: 121px;
    height: 86px;
    background-image: url("/static/images/no_event.png");
    background-size: 100% auto;
    overflow: hidden;
  }
  .no_event_font {
    text-align: center;
    margin-top: 10px;
    color: white;
    // font-family: "IBM Plex Sans"; // 该字体可免费商用,UI画的
    font-style: normal;
    letter-spacing: 2px;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
  }
}

.notice_content {
  /deep/ .ivu-modal-header {
    padding-bottom: 0;
    border-bottom: none;
    padding: 0px;
  }
  /deep/ .ivu-modal-footer {
    border-top: none;
    padding: 0;
  }
  /deep/ .ivu-modal-body {
    padding: 0px;
    margin-top: 20px;
  }
  /deep/ .ivu-modal-content {
    padding: 35px;
    color: #fff;
    background: #171717;
  }
  .notice_container {
    height: 100%;
    // border: 1px #ccc solid;
    // border-radius: 5px;
    overflow: hidden;
    position: relative;
    .father {
      overflow-y: auto;
      overflow-x: visible;
      position: relative;
      font-size: 16px;
      // padding-left: 48px;
      height: 400px;
      // margin-bottom: -17px;
      // margin-right: -17px;
      padding-right: 20px;
      .accessory {
        border-radius: 5px;
        // padding:18px;

        .accessory_item {
          margin-top: 15px;
        }
        .accessory_item:first-child {
          margin-top: 0;
        }
        .download_accessory {
          transition: all 0.5s;
          &:hover {
            color: #2d8cff;
            cursor: pointer;
          }
        }
      }
      /deep/ a {
        color: #2d8cf0 !important;
        span {
          color: #2d8cf0 !important;
        }
      }
    }
    .vertical-scroll {
      position: absolute;
      right: 0;
      width: 8px;
      top: 0;
      transition: all 0.3s ease-out;
      visibility: visible;
      background-color: #f5f5f5;
      height: 100%;
      border-radius: 1000px;
    }
    .rail {
      width: 100%;
      height: 100%;
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background-color: #ccc;
      border-radius: 1000px;
      cursor: pointer;
      -webkit-transition: background-color 0.3s;
      transition: background-color 0.3s;
    }
  }
}
.notice {
  /deep/ .ivu-modal-header {
    padding-bottom: 0;
    border-bottom: none;
    padding: 0px;
    font-size: 16px;
    .is_viewed {
      width: 142px;
      height: 26px;
      line-height: 26px;
      text-align: center;

      color: #969696;
      background: #303030;
      cursor: pointer;
    }
    .left {
      border-radius: 4px 0px 0px 4px;
    }
    .right {
      border-radius: 0px 4px 4px 0px;
    }
    .all_read {
      margin-left: 20px;
      display: flex;
      align-items: center;
      color: #2d8cff;
      cursor: pointer;
    }
    .selected {
      background: #d9d9d9;
      color: #000;
      font-weight: 600;
    }
  }
  /deep/ .ivu-modal-close {
    top: 28px;
    right: 35px;
  }
  /deep/ .ivu-modal-header {
    padding-top: 0px;
  }
  /deep/ .ivu-modal-content {
    padding: 20px;
    background: #171717;
  }
  /deep/ .ivu-modal-body {
    padding: 0px;
    margin-top: 20px;
    .message {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 4px;
      // height: 60px;
      border-bottom: 1px solid #4d4d4d;
      margin-bottom: 10px;
      .ivu-badge-dot {
        width: 12px;
        height: 12px;
      }
      .info {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        width: 296px;
        // height: 50px;
        .message_type {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          // padding: 10px;
          width: 50px;
          height: 50px;
          font-size: 16px;
          font-weight: 600;
          /* 100 */
          background: #ffffff;
          border-radius: 50%;
          .is_qa {
            position: absolute;
            align-items: center;
            height: 20px;
            width: inherit;
            .qa_text {
              background-image: url("/static/images/QA_tag.png");
              background-size: cover;
              background-position: center center;
              position: relative;
              height: 20px;
              width: inherit;
              line-height: 20px;
              /*right: 50px;*/
              top: 15px;
              /*color: white;*/
              /*font-weight: bold;*/
              /*font-size: 15px;*/
              /*border-radius: 5px;*/
              /*text-align: center;*/
              /*background-color: #31D26F;*/
              /*display: inline-block;*/
            }
          }
        }

        .text {
          margin-left: 15px;
          flex: 1;
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .message_title {
            color: #d9d9d9;
            width: 432px;
            font-size: 16px;
            font-weight: 700;
            white-space: nowrap; /* 不换行 */
            overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
            text-overflow: ellipsis;
          }
          .message_time {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #d9d9d9;
            .name {
              // max-width: calc(100% - 200px);
            }
          }
        }
      }
      .view {
        width: 55px;
        // height: 22px;
        padding: 5px;
        color: #303030;
        text-align: center;
        transition: all 0.5s;
        /* 85 */
        background: #d9d9d9;
        border-radius: 4px;
        cursor: pointer;
        &:hover {
          color: #d9d9d9;
          background: #303030;
        }
      }
    }

    .ivu-page {
      margin-top: 15px;
      color: #d9d9d9;
      text-align: right;
      .ivu-page-prev,
      .ivu-page-next {
        background: #171717;
        &:hover a {
          color: #2d8cf0;
        }
        a {
          color: #d9d9d9;
        }
      }
      .ivu-page-disabled {
        a {
          color: #8b8383;
        }
        &:hover a {
          color: #8b8383;
        }
      }
      .ivu-page-item {
        background: #171717;
        &:hover a {
          color: #2d8cf0;
        }
        a {
          color: #d9d9d9;
        }
      }
      .ivu-page-item-active a {
        color: #2d8cf0;
      }
    }
  }
  /deep/ .ivu-modal-footer {
    border-top: none;
    padding: 0;
  }
}

@media screen and (max-width: 600px) {
  .notice {
    /deep/ .ivu-modal-header {
      .is_viewed {
        width: 100px;
        height: 26px;
      }
      .all_read {
        font-size: 13px;
      }
    }
    /deep/ .ivu-modal-body {
      .message {
        .info {
          width: 80vw;
          .text {
            margin-left: 15px;
            flex: 1;
            height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .message_title {
              color: #d9d9d9;
              width: calc(300px - 65px - 24px);
              font-size: 16px;
              font-weight: 700;
              white-space: nowrap; /* 不换行 */
              overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
              text-overflow: ellipsis;
            }
            .message_time {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #d9d9d9;
            }
          }
        }
        .view {
        }
      }
      .ivu-page {
        .ivu-page-item {
          background: #171717;
          &:hover a {
            color: white;
          }
          &:active a {
            color: white;
          }
        }
        .ivu-page-item-active {
          a {
            &:hover {
              color: #2d8cf0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notice_modal.vue